<div class="grades-selector-wrapper">
    <button
        class="selenium-navigation-grades-selector grades-selector-btn"
        [ngStyle]="{
            'background-color': isGradesPanelOpened ? '#0a145a' : 'transparent'
        }"
        (click)="toggleGradesPanel()"
    >
        Grades
        <span [class]="isGradesPanelOpened ? 'arrow-up' : 'arrow-down'"></span>
    </button>
    <ng-container *ngIf="isGradesPanelOpened">
        <div class="arrow-indicator"></div>
        <div class="grades-panel" (mouseleave)="isGradesPanelOpened = false">
            <button
                class="gtm-navigation-grades-selector"
                *ngFor="let gradeBand of grades"
                [attr.data-gtmlabel]="gradeBand.gtmLabel"
                (click)="onGradeSelected(gradeBand)"
            >
                {{ gradeBand.label }}
            </button>
        </div>
    </ng-container>
</div>
